import type { SVGProps } from "react";
import { Zap } from "lucide-react";

export function SettleFastIcon(props: SVGProps<SVGSVGElement>) {
  return <Zap color="currentColor" {...props} className={`w-6 h-6 ${props.className ?? ""}`} />;
}
